import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDangerousGoods = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 22.5001V36.5001M30 42.5001H30.025M54.325 45.0001L34.325 10.0001C33.8889 9.23058 33.2565 8.59054 32.4923 8.14525C31.7281 7.69995 30.8595 7.46533 29.975 7.46533C29.0905 7.46533 28.2219 7.69995 27.4577 8.14525C26.6935 8.59054 26.0611 9.23058 25.625 10.0001L5.62501 45.0001C5.18421 45.7635 4.95308 46.6298 4.95503 47.5113C4.95698 48.3929 5.19195 49.2582 5.63612 50.0196C6.08029 50.7811 6.71788 51.4115 7.48425 51.8471C8.25061 52.2827 9.11853 52.508 10 52.5001H50C50.8773 52.4992 51.7388 52.2675 52.4982 51.8283C53.2576 51.3891 53.8881 50.7578 54.3263 49.9979C54.7645 49.2379 54.9951 48.376 54.9949 47.4988C54.9947 46.6215 54.7636 45.7598 54.325 45.0001Z",
		stroke: "#0A3C93",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDangerousGoods;
